import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@microsoft/signalr';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DivisionService } from 'src/app/services/division.service';
import { DriverService } from 'src/app/services/driver.service';
import { RegionService } from 'src/app/services/region.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { DepartmentType } from 'src/enum/departmenttype';
import { PopupexeclService } from 'src/app/services/popupexecl.service';
const Space = '            ';
@Component({
  selector: 'app-smamdashboardpopup',
  templateUrl: './smamdashboardpopup.component.html',
  styleUrls: ['./smamdashboardpopup.component.scss']
})
export class SmamdashboardpopupComponent implements OnInit {

   displayedColumns: string[] = [
          'sno',
          'division',
          'gen',

          'scp',
          'tsp',
          ];
          displayedColumns2: string[] =[
            'sno',
            'productType',
            'noOfMachinery'

          ];

            // nestedData= [
            //   { productType: 'Tractor', noOfMachinery: 10 },
            //   { productType: 'Harvester', noOfMachinery: 5 },
            //   { productType: 'Plough', noOfMachinery: 7 }
            // ]
          // dataField = {
          //   nestedData: [
          //     { 'productType': 'Tractor', noOfMachinery: 10 },
          //     { productType: 'Harvester', noOfMachinery: 5 },
          //     { productType: 'Plough', noOfMachinery: 7 }
          //   ]
          // };
      datasource = [];
      datasource1=[];
      data = [];
      nestedData=[];
      dataSource = new MatTableDataSource(this.data);
      dataSource1= new MatTableDataSource(this.nestedData);
      @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
      @ViewChild(MatSort, { static: true }) sort: MatSort;
      aed: boolean;
      usedepartmentId: number;
      roleId: number;
      regionId: any;
      districtId: number;
      subDivisionId: number;
      smamDashboard: any;
      pendingGenDivisionTarget:[]
       public departmentType = DepartmentType;
       excelColumns:any[];
       index:1;




  constructor(
     public dialogRef: MatDialogRef<SmamdashboardpopupComponent>,
        @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
        public addServiceDialog: MatDialog,
            private userSessionService: UserSessionService,
            private excelService: PopupexeclService
            ) {
    this.usedepartmentId = parseInt(this.userSessionService.getUserdepartmentId());
    this.roleId = this.userSessionService.roleId();
    this.regionId = parseInt(this.userSessionService.getRegionId());
    if (this.usedepartmentId == this.departmentType.SMAM) {
      this.districtId = parseInt(this.userSessionService.getDivisionId());
      this.subDivisionId = parseInt(this.userSessionService.getSubDivisionId());
      this.aed = true;
    } else {
      this.districtId = parseInt(this.userSessionService.getUserdistrictId());
      this.subDivisionId = parseInt(this.userSessionService.getUserBlockId());
      this.aed = false;
    }
  

  }

    ngOnInit() {


      this.smamDashboard = this.dataRecievedData.smamDashboard;

      const type = this.dataRecievedData?.type;
      const list = this.dataRecievedData?.list || [];

      // this.pendingGenDivisionTarget = list
      // .filter(item => Array.isArray(item.pendingGenDivisionTargetList) && item.pendingGenDivisionTargetList.length > 0)
      // .flatMap(item => item.pendingGenDivisionTargetList);
      // console.log(this.pendingGenDivisionTarget,'======================');


      list.sort((a, b) => {
        const nameA = a.divisionName?.toLowerCase() || '';
        const nameB = b.divisionName?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      });

      // Map your data and columns based on type
      switch (type) {
        case 1:
          this.displayedColumns = ['sno', 'division','gen', 'scp', 'tsp'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            gen: item.pendingGenDivisionTarget,
            scp: item.pendingScDivisionTarget,
            tsp: item.pendingStDivisionTarget,
            pendingScDivisionTargetList: item.pendingScDivisionTargetList,
            // console.log(pendingScDivisionTargetList);

            pendingStDivisionTargetList: item.pendingStDivisionTargetList,
            pendingGenDivisionTargetList: item.pendingGenDivisionTargetList,
          }));
          break;

        case 2:
        case 3:
          this.displayedColumns = ['sno', 'division', 'subdivision','gen', 'scp', 'tsp'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            scp: item.pendingScDivisionTarget,
            tsp: item.pendingStDivisionTarget,
            gen: item.pendingGenDivisionTarget,
            pendingScDivisionTargetList: item.pendingScDivisionTargetList,
            // console.log(pendingScDivisionTargetList);

            pendingStDivisionTargetList: item.pendingStDivisionTargetList,
            pendingGenDivisionTargetList: item.pendingGenDivisionTargetList,
          }));
          break;

        case 4:
          this.displayedColumns = ['sno', 'division', 'subdivision', 'pendingPreverification'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            pendingPreverification: item.pendingPreverification,
            pendingPreverificationList:item.pendingPreverificationList,
          }));
          break;

        case 5:
        case 18:
          this.displayedColumns = type === 18
            ? ['sno', 'division', 'subdivision', 'pendingDealerSelection']
            : ['sno', 'division', 'subdivision', 'pendingSupplyOrderIssue'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            pendingDealerSelection: item.pendingDealerSelection,
            pendingSupplyOrderIssue: item.pendingSupplyOrderIssue,
            pendingDealerSelectionList:item.pendingDealerSelectionList,
            pendingSupplyOrderIssueList:item.pendingSupplyOrderIssueList
          }));
          break;

        case 6:
          this.displayedColumns = ['sno', 'division', 'subdivision', 'pendingMachinerySupplied'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            pendingMachinerySupplied: item.pendingMachinerySupplied,
            pendingMachinerySuppliedList:item.pendingMachinerySuppliedList
          }));
          break;

        case 7:
          this.displayedColumns = ['sno', 'division', 'subdivision', 'pendingPhysicalVerification'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            pendingPhysicalVerification: item.pendingPhysicalVerification,
            pendingPhysicalVerificationList:item.pendingPhysicalVerificationList
          }));
          break;

        case 8:
          this.displayedColumns = ['sno', 'division', 'subdivision', 'pendingSubsidyReleased'];
          this.data = list.map((item, i) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            pendingSubsidyReleased: item.pendingSubsidyReleased,
            pendingSubsidyReleasedList:item.pendingSubsidyReleasedList
          }));
          break;

        case 9:
        case 10:
        case 11:
        case 15:
        case 16:
        case 17:
        case 19:
        case 20: {
          const dashboard = this.dataRecievedData?.dashboard;
          const listByType: { [key: number]: any } = {
            9: dashboard?.pendingVehiclePlacedDealerPremisesList,
            10: dashboard?.pendingDealerPremisesVerificationList,
            11: dashboard?.pendingManufacturerApprovalList,
            15: dashboard?.pendingFarmerSubsidyContributionList,
            16: dashboard?.pendingFarmerContributionList,
            17: dashboard?.pendingSubsidyReleaseToFarmerList,
            19: dashboard?.pendingAdditionalSubsidyList,
            20: dashboard?.notEligibleAdditionalSubsidyList
          };
          const eventList: any[] = listByType[type] || [];
          this.displayedColumns = ['sno', 'division', 'subdivision', 'eventPendingCount'];
          this.data = eventList.map((item: any, i: number) => ({
            sno: i + 1,
            division: item.divisionName,
            subdivision: item.subDivisionName,
            eventPendingCount: item.pendingCount
          })) as any;
          break;
        }
      }

      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.seconTable()
    }

    seconTable(){

      // this.dataSource1 = new MatTableDataSource(this.pendingGenDivisionTarget);
      // this.dataSource1.sort = this.sort;
      // this.dataSource1.paginator = this.paginator;
    }


  cancel() {
    this.dialogRef.close();
}
exportCombinedExcel(): void {
  const summaryData: any[] = [];
  const detailedData: any[] = [];

  const type = this.dataRecievedData?.type;
  let fileName = '';
  let total1 = 0, total2 = 0, total3 = 0;
  switch (type) {
    case 1:
      fileName = 'Division_Target_Report';
      break;
    case 2:
      fileName = 'Target Not Assigned To The Village By The Sub Division';
      break;
    case 3:
      fileName = 'Machinary Not Selected';
      break;
    case 4:
      fileName = 'Pre-Verification Not Completed';
      break;
    case 5:
      fileName = 'Supply Order Not Issued';
      break;
    case 6:
      fileName = 'Machinery Not Supplied';
      break;
    case 7:
      fileName = 'Physical Verification Not Completed';
      break;
    case 8:
      fileName = 'Subsidy Not Released';
      break;
    case 9:
      fileName = 'Vehicle Not Placed In Dealer Premises';
      break;
    case 10:
      fileName = 'Dealer Premises Verification Not Completed';
      break;
    case 11:
      fileName = 'Manufacturer Approval Pending';
      break;
    case 15:
      fileName = 'Farmer Subsidy Contribution Pending';
      break;
    case 16:
      fileName = 'Farmer Contribution Pending';
      break;
    case 17:
      fileName = 'Subsidy Release To Farmer Pending';
      break;
    case 19:
      fileName = 'Additional Subsidy Pending';
      break;
    case 20:
      fileName = 'Additional Subsidy Not Eligible';
      break;
    case 18:
      fileName = 'Dealer Selection Not Completed';
      break;
    default:
      fileName = 'Combined_Report';
  }
  // ======= Sheet 1: Summary Report =======
  if (this.data && this.data.length > 0) {
    this.data.forEach((element, index) => {
      switch (type) {
        case 1:
          total1 += +element.scp;
          total2 += +element.tsp;
          total3 += +element.gen;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'General Target': element.gen,
            'SC Target': element.scp,
            'ST Target': element.tsp
          });
          break;

        case 2:
        case 3:
          total1 += +element.scp;
          total2 += +element.tsp;
          total3 += +element.gen;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'General Target': element.gen,
            'SC Target': element.scp,
            'ST Target': element.tsp
          });
          break;

        case 4:
          total1 += +element.pendingPreverification;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Pre-verification': element.pendingPreverification
          });
          break;

        case 5:
          total1 += +element.pendingDealerSelection;
          total2 += +element.pendingSupplyOrderIssue;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Dealer Selection': element.pendingDealerSelection,
            'Pending Supply Order Issue': element.pendingSupplyOrderIssue
          });
          break;

        case 6:
          total1 += +element.pendingMachinerySupplied;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Machinery Supplied': element.pendingMachinerySupplied
          });
          break;

        case 7:
          total1 += +element.pendingManufactureApproved;
          total2 += +element.pendingPhysicalVerification;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Manufacturer Approved': element.pendingManufactureApproved,
            'Pending Physical Verification': element.pendingPhysicalVerification
          });
          break;

        case 8:
          total1 += +element.pendingSubsidyReleased;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Subsidy Released': element.pendingSubsidyReleased
          });
          break;

        case 9:
          total1 += +element.eventPendingCount;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Vehicle Placed In Dealer Premises': element.eventPendingCount
          });
          break;

        case 10:
          total1 += +element.eventPendingCount;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Dealer Premises Verification': element.eventPendingCount
          });
          break;

        case 11:
        case 15:
        case 16:
        case 17:
        case 19:
        case 20:
          total1 += +element.eventPendingCount;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Count': element.eventPendingCount
          });
          break;

        case 18:
          total1 += +element.pendingDealerSelection;
          summaryData.push({
            'S.No': index + 1,
            'Division Name': element.division,
            'Sub Division Name': element.subdivision,
            'Pending Dealer Selection': element.pendingDealerSelection
          });
          break;
      }
    });

    // Add total row to summary
    let totalRow: any = { 'S.No': '', 'Division Name': 'Total' };
    switch (type) {
      case 1:
        totalRow['General Target'] = total3;
        totalRow['SC Target'] = total1;
        totalRow['ST Target'] = total2;
        break;
      case 2:
      case 3:
        totalRow['Sub Division Name'] = '';
        totalRow['General Target'] = total3;
        totalRow['SC Target'] = total1;
        totalRow['ST Target'] = total2;
        break;
      case 4:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Pre-verification'] = total1;
        break;
      case 5:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Dealer Selection'] = total1;
        totalRow['Pending Supply Order Issue'] = total2;
        break;
      case 6:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Machinery Supplied'] = total1;
        break;
      case 7:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Manufacturer Approved'] = total1;
        totalRow['Pending Physical Verification'] = total2;
        break;
      case 8:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Subsidy Released'] = total1;
        break;
      case 9:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Vehicle Placed In Dealer Premises'] = total1;
        break;
      case 10:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Dealer Premises Verification'] = total1;
        break;
      case 11:
      case 15:
      case 16:
      case 17:
      case 19:
      case 20:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Count'] = total1;
        break;
      case 18:
        totalRow['Sub Division Name'] = '';
        totalRow['Pending Dealer Selection'] = total1;
        break;
    }
    summaryData.push(totalRow);
  }

  // ======= Sheet 2: Detailed Report =======
  let sno = 1;
  const list = this.dataRecievedData.list || [];

  list.forEach(item => {
    const division = item.divisionName;
    const subDivision = item.subDivisionName;

    const addDetails = (array, categoryOrStatus, labelKey = 'Category') => {
      if (Array.isArray(array)) {
        array.forEach(product => {
          const row: any = {
            'S.No': sno++,
            'Division': division,
            'Subdivision': subDivision,
            'Product Name': product.productName,
            'Count': product.count
          };
          if (categoryOrStatus) row[labelKey] = categoryOrStatus;
          detailedData.push(row);
        });
      }
    };

    addDetails(item.pendingGenDivisionTargetList, 'GEN');
    addDetails(item.pendingScDivisionTargetList, 'SC');
    addDetails(item.pendingStDivisionTargetList, 'ST');
    addDetails(item.pendingPreverificationList, null);
    addDetails(item.pendingDealerSelectionList, 'Waiting for Dealer Section', 'Status');
    addDetails(item.pendingSupplyOrderIssueList, 'Supply Order Not Issued', 'Status');
    addDetails(item.pendingMachinerySuppliedList, null);
    addDetails(item.pendingManufactureApprovedList, 'Manufacturer Not Approved', 'Status');
    addDetails(item.pendingPhysicalVerificationList, 'Physical Verification Not Completed', 'Status');
    addDetails(item.pendingSubsidyReleasedList, null);
    addDetails(item.pendingVehiclePlacedDealerPremisesList, 'Vehicle Not Placed In Dealer Premises', 'Status');
    addDetails(item.pendingDealerPremisesVerificationList, 'Dealer Premises Verification Not Completed', 'Status');
  });

  // ======= Generate Excel =======
  const summarySheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(summaryData);
  const detailedSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(detailedData);

  const workbook: XLSX.WorkBook = {
    Sheets: {
      'Summary Report': summarySheet,
      'Detailed Report': detailedSheet
    },
    SheetNames: ['Summary Report', 'Detailed Report']
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob: Blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  });

  FileSaver.saveAs(blob, `${fileName}.xlsx`);
}


}
